import { render } from "./heatingBuildingController.vue?vue&type=template&id=ffedb74e&scoped=true"
import script from "./heatingBuildingController.vue?vue&type=script&lang=js"
export * from "./heatingBuildingController.vue?vue&type=script&lang=js"

import "./heatingBuildingController.vue?vue&type=style&index=0&id=ffedb74e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffedb74e"]])

export default __exports__